export default __webpack_public_path__ + "static/media/conteudo_extra_13_25.8f78a19c.jpg";